module.exports = __webpack_public_path__ + "img/cta.fcea9ef0.svg";